import { render, staticRenderFns } from "./InfoBulb.vue?vue&type=template&id=2951c689&scoped=true&"
import script from "./InfoBulb.vue?vue&type=script&lang=ts&"
export * from "./InfoBulb.vue?vue&type=script&lang=ts&"
import style0 from "./InfoBulb.vue?vue&type=style&index=0&id=2951c689&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2951c689",
  null
  
)

export default component.exports